import { Skeleton } from "@/components/ui/skeleton";

/**
 * App-shell skeleton shown during route-level code splitting.
 * Mirrors the PageLayout structure so the transition feels seamless.
 */
export const RouteLoading = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header skeleton */}
      <div className="fixed top-0 left-0 right-0 z-50 h-[60px] bg-background border-b px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Skeleton className="h-8 w-8 rounded-md" />
          <Skeleton className="h-5 w-24" />
        </div>
        <Skeleton className="h-8 w-8 rounded-md" />
      </div>

      {/* Content skeleton */}
      <main className="container mx-auto px-6 pt-20 pb-8 max-w-2xl space-y-4 skeleton-stagger">
        <Skeleton className="h-8 w-48 mb-2" />
        <Skeleton className="h-40 w-full rounded-xl" />
        <Skeleton className="h-24 w-full rounded-xl" />
        <Skeleton className="h-32 w-full rounded-xl" />
      </main>
    </div>
  );
};
